// src/redux/actions/jobTypeActions.js
import {
    FETCH_SALARYTYPE_REQUEST,
    FETCH_SALARYTYPE_SUCCESS,
    FETCH_SALARYTYPE_FAILURE,
    SET_SELECTED_SALARYTYPE,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchSalaryType = () => async (dispatch) => {
    dispatch({ type: FETCH_SALARYTYPE_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetSalaryTypesDDL`);
      let salaryTypeList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
        }
    })
      dispatch({
        type: FETCH_SALARYTYPE_SUCCESS,
        payload: salaryTypeList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_SALARYTYPE_FAILURE,
        payload: error.message,
      });
    }
  };
  
  
  export const selectSalaryType = (salaryTypeId) => ({
    type: SET_SELECTED_SALARYTYPE,
    payload: salaryTypeId,
  });
  